import { Profile } from '@omneo/omneo-sdk'

/**
 * Returns the profile icon if present
 * @param {Profile} profile
 * @returns {string}
 */
export const getProfileIconIndex = (profile, icons) => {
  return !profile?.avatar_url
    ? 0
    : icons
      .findIndex((i) => {
        return profile.avatar_url.includes(i.icon)
      })
      ?.toString()
}

/**
 *
 * Returns a string url to a image path
 *
 * @param {string} selectedIndex
 * @param {string[]} icons
 * @returns {string}
 */
export const getProfileIcon = (selectedIndex, icons) => {
  const index = parseInt(selectedIndex)
  const url = icons[index]?.icon
  return url ? 'https:'.concat(url) : undefined
}
